module.exports = __webpack_public_path__ + "img/chips50.243ccd89.webp";